import React from 'react';

import Input from 'antd/es/input';
import Form from 'antd/es/form';

import { Row, Col } from 'components/layout';

const AgencyForm = ({ form }) => (
  <Form
    form={form}
    layout="vertical"
    hideRequiredMark={true}
    onFinish={form.onSubmit}
  >
    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item
          label="Agency Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Agency name is required',
            },
          ]}
        >
          <Input placeholder="Agency Name" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Contact Person"
          name="contact_person"
          rules={[
            {
              required: true,
              message: 'Contact person name is required',
            },
          ]}
        >
          <Input placeholder="Contact person full name" />
        </Form.Item>
      </Col>
    </Row>

    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item
          label="Phone Number"
          name="phone"
        >
          <Input placeholder="Enter phone number" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Email"
          name="email"
        >
          <Input placeholder="Enter email" />
        </Form.Item>
      </Col>
    </Row>

    <Form.Item
      label="Agency Address"
      name="address"
    >
      <Input placeholder="Enter agency address" />
    </Form.Item>

    <Form.Item
      label="Notes"
      name="notes"
    >
      <Input.TextArea rows={3} placeholder="Notes" />
    </Form.Item>
  </Form>
);

export default AgencyForm;